import { ECustomerCommissionState, TCommissionState, TCustomerCommissionState } from '../schemas';

export const COMMISSION_STATE_TO_CUSTOMER_COMMISSION_STATE: Record<TCommissionState, TCustomerCommissionState> = {
    ENQUIRY_FROM_WEBSITE: ECustomerCommissionState.ENQUIRY,
    ENQUIRY_FROM_CUSTOMER_ZONE: ECustomerCommissionState.ENQUIRY,
    CREATED: ECustomerCommissionState.ENQUIRY,
    ACCEPTED: ECustomerCommissionState.PROCESSING,
    WAITING_FOR_OFFERS: ECustomerCommissionState.PROCESSING,
    WAITING_FOR_PRICE_APPROVAL: ECustomerCommissionState.PROCESSING,
    WAITING_FOR_OFFERS_FOR_CUSTOMER: ECustomerCommissionState.WAITING_FOR_OFFERS,
    WAITING_FOR_CUSTOMER_APPROVAL: ECustomerCommissionState.WAITING_FOR_APPROVAL,
    CARRIER_ASSIGNED: ECustomerCommissionState.VEHICLE_ASSIGNED,
    ORDER_SENT: ECustomerCommissionState.VEHICLE_ASSIGNED,
    IN_PROGRESS: ECustomerCommissionState.IN_PROGRESS,
    COMPLETED: ECustomerCommissionState.COMPLETED,
    IN_CLAIM: ECustomerCommissionState.IN_CLAIM,
    CANCELLED: ECustomerCommissionState.CANCELLED,
    CANCELLATION_APPROVAL: ECustomerCommissionState.CANCELLATION_APPROVAL,
    CANCELLED_WITH_FAILED_ATTEMPT: ECustomerCommissionState.CANCELLED_WITH_FAILED_ATTEMPT,
};
